import React from 'react';
import CompanyUser from "../../../../core/model2/company-user-new/company-user";
import PopoverMenuItem from "../../../../core/gd-components/popover-menu/popover-menu/menu-item";

type Props = {
    companyUser : CompanyUser;
    className?  : string
    hidePopover : callback
}

export default function NavigationMenu_UserContextMenu(props: Props) {

    const openInfo = ()=> {
        gd.goTo('u/{0}/info'.f(props.companyUser.id))
        props.hidePopover()
    }

    const openSummary = ()=> {
        gd.goTo('u/{0}/summary'.f(props.companyUser.id))
        props.hidePopover()
    }

    const onDelete = ()=> {
        gd.goTo('o/users/delete/{0}'.f(props.companyUser.user.id))
        props.hidePopover()
    }

    return (
        <div className="ui5-popover-menu w-200">
            <PopoverMenuItem icon="ii5-information" label="Info"    onClick={openInfo}/>
            <PopoverMenuItem icon="i5-my-work-new"  label="Summary" onClick={openSummary}/>
            <div className="separator"/>
            <PopoverMenuItem icon="i5-trash-alt"    label="Delete"  onClick={onDelete}/>
        </div>
    );
}
